import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import withRouter from "../../../helpers/withRouter";

interface AdminHeaderProps {
  location: any;
  navigate: any;
}

const NAV_LINKS: Array<{ label: string; to: string }> = [
  { label: "Users", to: "/admin/users" },
  { label: "Boosters", to: "/admin/booster" },
  { label: "Pricing Model", to: "/admin/pricing-model" },
  { label: "UTM Links", to: "/admin/utm" },
  { label: "Messages", to: "/admin/messages" },
  { label: "Email Campaigns", to: "/admin/email-campaigns" },
];

class AdminHeader extends React.Component<AdminHeaderProps> {
  logout() {
    localStorage.removeItem("adminToken");
    this.props.navigate("/admin/login");
  }

  render() {
    return (
      <header className="bg-white/80 backdrop-blur border-b border-gray-100 sticky top-0 z-40">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-4 py-4 lg:flex-row lg:items-center lg:justify-between">
            <Link to="/admin" className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-xl bg-[var(--primary-color)]/10 flex items-center justify-center">
                <img
                  src="/assets/images/logo.png"
                  alt="Bookish Admin"
                  className="h-7 w-7 object-contain"
                />
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-gray-500 font-semibold">
                  Admin
                </div>
                <div className="text-lg font-semibold text-gray-900">
                  Dashboard
                </div>
              </div>
            </Link>

            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-6">
              <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white p-1 shadow-sm">
                {NAV_LINKS.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className={({ isActive }) =>
                      [
                        "inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold transition-colors",
                        isActive
                          ? "bg-[var(--primary-color)] text-white shadow"
                          : "text-gray-600 hover:text-[var(--primary-color)] hover:bg-[var(--primary-color)]/10",
                      ].join(" ")
                    }
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>

              <button
                type="button"
                onClick={() => this.logout()}
                className="inline-flex items-center justify-center rounded-full border border-red-200 px-4 py-2 text-sm font-semibold text-red-500 transition hover:bg-red-50 hover:border-red-300"
              >
                <img
                  className="mr-2 h-5 w-5"
                  src="/assets/images/logout.svg"
                  alt=""
                />
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(AdminHeader);
